import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImageCautionArea = _resolveComponent("UploadImageCautionArea")!
  const _component_FormSelectGroup = _resolveComponent("FormSelectGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_IdImage = _resolveComponent("IdImage")!
  const _component_UploadImageForm = _resolveComponent("UploadImageForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UploadImageCautionArea, {
      cautions: _ctx.cautions,
      class: "mb-4"
    }, null, 8, ["cautions"]),
    _createTextVNode(),
    _createVNode(_component_ValidationProvider, {
      name: "証明書の種類",
      tag: "div",
      rules: "required",
      vid: "identificationType"
    }, {
      default: _withCtx((validationState) => [
        _createVNode(_component_FormSelectGroup, {
          label: "身分証明書",
          appLabelText: "必須",
          value: _ctx.inputValues.identificationType,
          options: _ctx.selectedOptions,
          disabled: _ctx.disabled,
          "validation-state": validationState,
          class: "mb-4",
          onInput: ($event: any) => (
          _ctx.onChangeIdentificationType($event, validationState.handleChange)
        )
        }, null, 8, ["value", "options", "disabled", "validation-state", "onInput"])
      ]),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_UploadImageForm, {
      modelValue: _ctx.inputValues.identificationImage,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.identificationImage) = $event)),
      title: "写真アップロード（オモテ面）",
      appLabelText: "必須",
      appLabelVariant: "red",
      photoGraphingType: "id",
      isFrontCamera: false,
      isCameraActive: _ctx.isCameraActiveValue,
      "onUpdate:isCameraActive": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCameraActiveValue) = $event)),
      options: _ctx.options,
      disabled: _ctx.disabled,
      disabledText: _ctx.disabledText,
      class: "mb-4",
      imageDescription: "表面"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IdImage, {
          imageUrl: _ctx.inputValues.identificationImage
        }, null, 8, ["imageUrl"])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue", "isCameraActive", "options", "disabled", "disabledText"]),
    _createTextVNode(),
    (_ctx.isShowBackImage)
      ? (_openBlock(), _createBlock(_component_UploadImageForm, {
          key: 0,
          modelValue: _ctx.inputValues.identificationBackImage,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValues.identificationBackImage) = $event)),
          title: "写真アップロード（ウラ面）",
          appLabelText: "任意",
          appLabelVariant: "mild",
          photoGraphingType: "id",
          isFrontCamera: false,
          isCameraActive: _ctx.isCameraActiveValue,
          "onUpdate:isCameraActive": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCameraActiveValue) = $event)),
          options: _ctx.options,
          disabled: _ctx.disabled,
          disabledText: _ctx.disabledText,
          class: "mb-4",
          imageDescription: "裏面"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IdImage, {
              imageUrl: _ctx.inputValues.identificationBackImage
            }, null, 8, ["imageUrl"])
          ], undefined, true),
          _: 1
        }, 8, ["modelValue", "isCameraActive", "options", "disabled", "disabledText"]))
      : _createCommentVNode("", true)
  ]))
}